const angular = require('angular');
const ngMessages = require('angular-messages');
const ngSanitize = require('angular-sanitize');
const uiRouter = require('angular-ui-router');
const restangular = require('restangular'); // eslint-disable-line no-unused-vars
const olyDialog = require('oly-dialog');

const olyCommonModule = require('../olycommon/olycommon.module');

const wowCommonModuleName = 'wowApp.common';

angular.module(wowCommonModuleName, [
    olyCommonModule,
    ngMessages,
    ngSanitize,
    uiRouter,
    'restangular',
    olyDialog,
]);

// Components

// high priority modules
require('./bootstrap');
require('./deploymentswitch');
require('./config');
require('./feature');
require('./settings');

require('./bootstrap');
require('./breakpoints');
require('./button');
require('./copyright');
require('./deliverypass');
require('./dialog');
require('./dynamiccontent');
require('./emailvalidator');
require('./errorpage');
require('./filters');
require('./footer');
require('./heartbeat');
require('./lists');
require('./loadingindicator');
require('./loyalty/loyalty-points-calculator');
require('./pagemetadata');
require('./pastshops');
require('./paypal');
require('./productgroup');
require('./savedlists');
require('./shoppagestate');
require('./smallformatmenu');
require('./socialmedia');
require('./suggestedlist');
require('./unsubscribeedm');
require('../olycommon/localStorageWrapper');

module.exports = wowCommonModuleName;



// WEBPACK FOOTER //
// ./src/common/common.module.js